import styled from 'styled-components'
import vector from '../../../../assets/equipment/vector.svg'

export const MainContainer = styled.div`
  background-color: #f4f4f4;
  overflow-y: visible;
  
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  ::-webkit-scrollbar-track {
    background: #c0c0c0;
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #ffffff;
    border-radius: 10px;
    border: 2px solid #c0c0c0;
  }
`

export const BreadcrumbsContainer = styled.nav`
  font-size: 12px;
  margin-top: 0;
  margin-bottom: 8px;
  
  ol {
    list-style: none;
    padding: 0;
    padding-inline-start: 0;
    margin: 0;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  
  li {
    display: flex;
    align-items: center;
    color: #666;
    
    &:not(:last-child)::after {
      content: '>';
      margin: 0 8px;
      color: #999;
    }
    
    a {
      text-decoration: none;
      color: #0090d3;
      white-space: nowrap;
      cursor: pointer;
    }
    
    &:last-child {
      span {
        color: #696969;
        white-space: nowrap;
        cursor: default;
      }
    }
  }
`

export const CardTitle = styled.h2`
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 12px 0;
  padding-bottom: 0;
`

export const StyledCard = styled.div`
  background-color: #fff;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;
`

export const FormGrid = styled.div<{ cols: number }>`
  display: grid;
  grid-template-columns: repeat(${(props) => props.cols}, 1fr);
  gap: 16px 24px;
  align-items: start;
  
  @media (max-width: 992px) {
    grid-template-columns: ${(props) =>
      props.cols === 3 ? 'repeat(2, 1fr)' : 'repeat(2, 1fr)'};
  }
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

export const StyledFormGroup = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;

  label {
    font-size: 13px;
    color: #303030;
    margin-bottom: 6px;
    font-weight: bold;
    min-height: 20px;
    display: block;
  }

  input,
  select {
    padding: 6px 14px;
    border: 1px solid #ebebeb;
    border-radius: 100px;
    font-size: 13px;
    outline: none;
    width: 100%;
    box-sizing: border-box;
    height: 36px;
    line-height: 20px;
    background-color: #ebebeb;
    color: #696969;

    &::placeholder {
      color: #999;
    }

    &:disabled {
      background-color: #c4c4c4;
      color: #696969;
      cursor: not-allowed;
    }
  }

  textarea {
    padding: 10px 14px;
    border: 1px solid #ebebeb;
    border-radius: 12px;
    font-size: 13px;
    outline: none;
    width: 100%;
    box-sizing: border-box;
    min-height: 80px;
    line-height: 1.5;
    background-color: #ebebeb;
    color: #696969;
    resize: vertical;
    font-family: inherit;

    &::placeholder {
      color: #999;
    }

    &:disabled {
      background-color: #c4c4c4;
      color: #696969;
      cursor: not-allowed;
    }
  }
  
  select {
    background-image: url(${vector});
    background-size: 18px 9px;
    background-repeat: no-repeat;
    background-position: right 15px center;
    padding-right: 2.5rem;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    cursor: pointer;

    option[value=''] {
      color: #999;
    }
    
    option {
      color: #333;
      background-color: white;
    }
  }
`

export const ActionButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`

export const ImportButton = styled.button`
  background-color: transparent;
  color: #0090d3;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 6px;
  
  svg {
    width: 16px;
    height: 16px;
  }
`

export const CancelButton = styled.button`
  background-color: #ffffff;
  color: #0090d3;
  border: 1px solid #0090d3;
  padding: 8px 16px;
  border-radius: 100px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
`

export const SaveButton = styled.button<{ disabled?: boolean }>`
  background-color: ${props => props.disabled ? '#e0e0e0' : '#0090d3'};
  color: ${props => props.disabled ? '#999' : 'white'};
  border: none;
  padding: 8px 16px;
  border-radius: 100px;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 8px;

  img {
    width: 16px;
    height: 16px;
  }
`

export const GraduationGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`

export const GraduationButton = styled.button<{ $isSelected: boolean }>`
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  color: ${(props) => (props.$isSelected ? '#0090d3' : '#666')};
  background-color: ${(props) => (props.$isSelected ? '#e6f7ff' : 'transparent')};
  border: 1px solid ${(props) => (props.$isSelected ? '#0090d3' : '#e0e0e0')};
  border-radius: 100px;
  cursor: pointer;
  min-width: 50px;
`

export const CompositionTableWrapper = styled.div`
  --sticky-first-width: 140px;
  --sticky-second-width: 220px;
  overflow-x: auto;
  margin-bottom: 12px;
  position: relative;
  background-color: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 0;
  isolation: isolate;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: calc(var(--sticky-first-width) + var(--sticky-second-width) + 2px);
    background-color: #fff;
    pointer-events: none;
    z-index: 20;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }

  &::-webkit-scrollbar {
    height: 6px;
  }
  &::-webkit-scrollbar-track {
    background: #f5f5f5;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #d0d0d0;
    border-radius: 4px;
  }
`

export const CompositionTable = styled.div`
  display: table;
  width: max-content;
  border-spacing: 0;
  min-width: 100%;
  img {
    max-width: 32px;
    max-height: 32px;
    width: auto;
    height: auto;
    object-fit: contain;
    display: inline-block;
  }
`

export const CompositionTableHeader = styled.div`
  display: table-row;
  > *:last-child {
    width: 48px;
    white-space: nowrap;
  }
  
  span {
    display: table-cell;
    box-sizing: border-box;
    font-size: 11px;
    font-weight: 700;
    color: #4b5563;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    padding: 12px 14px;
    vertical-align: middle;
    white-space: nowrap;
    background-color: #f9fafb;
    border-bottom: 1px solid #e5e7eb;
    
    &:first-child {
      width: var(--sticky-first-width);
      position: sticky;
      left: 0;
      z-index: 31;
      border-right: 1px solid #f0f0f0;
    }
    &:nth-child(2) {
      width: var(--sticky-second-width);
      position: sticky;
      left: var(--sticky-first-width);
      z-index: 30;
      border-right: 1px solid #f0f0f0;
      box-shadow: -1px 0 0 #fff;
    }
    &:nth-child(3) {
      width: 130px;
    }
    &:nth-child(4) {
      width: 200px;
    }
    &:nth-child(5) {
      width: 150px;
    }
    &:nth-child(6) {
      width: 130px;
    }

    &.color-column {
      width: 170px;
      min-width: 170px;
    }
  }
`

export const CompositionTableRow = styled.div`
  display: table-row;

  > * {
    display: table-cell;
    padding: 0;
    vertical-align: middle;
    min-height: 44px;
    border-bottom: 1px solid #f3f4f6;
  }

  &:last-child > * {
    border-bottom: none;
  }

  > *:last-child {
    width: 48px;
    text-align: center;
  }
`

export const TableCell = styled.div<{ $sticky?: 'first' | 'second' }>`
  display: table-cell;
  box-sizing: border-box;
  padding: 0;
  vertical-align: middle;
  background-color: #fff;
  position: relative;
  z-index: 1;
  
  ${(props) => props.$sticky === 'first' && `
    position: sticky;
    left: 0;
    z-index: 29;
    width: var(--sticky-first-width);
    min-width: var(--sticky-first-width);
    max-width: var(--sticky-first-width);
    border-right: 1px solid #f0f0f0;
  `}
  
  ${(props) => props.$sticky === 'second' && `
    position: sticky;
    left: var(--sticky-first-width);
    z-index: 28;
    width: var(--sticky-second-width);
    min-width: var(--sticky-second-width);
    max-width: var(--sticky-second-width);
    border-right: 1px solid #f0f0f0;
    box-shadow: -1px 0 0 #fff;
  `}
  
  &.color-column {
    width: 170px;
    min-width: 170px;
  }
`

export const TableSelect = styled.select`
  display: block;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  margin: 0;
  border: none;
  border-radius: 0;
  padding: 12px 32px 12px 14px;
  font-size: 13px;
  font-family: inherit;
  font-weight: 400;
  color: #1f2937;
  line-height: 1.35;
  background-color: transparent;
  background-image: url(${vector});
  background-size: 14px 7px;
  background-repeat: no-repeat;
  background-position: right 12px center;
  cursor: pointer;
  outline: none;
  min-height: 44px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  &:focus {
    background-color: #f9fafb;
    box-shadow: inset 0 0 0 1px #0090d3;
  }

  option {
    color: #1f2937;
    background-color: white;
  }

  option[value=''] {
    color: #9ca3af;
  }

  &:disabled {
    background-color: #f3f4f6;
    color: #9ca3af;
    cursor: not-allowed;
    opacity: 1;
    box-shadow: none;
  }
`

export const TableInput = styled.input`
  display: block;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  margin: 0;
  border: none;
  border-radius: 0;
  padding: 12px 14px;
  font-size: 13px;
  font-family: inherit;
  font-weight: 400;
  color: #1f2937;
  line-height: 1.35;
  background-color: transparent;
  outline: none;
  min-height: 44px;

  &::placeholder {
    color: #9ca3af;
  }

  &:focus {
    background-color: #f9fafb;
    box-shadow: inset 0 0 0 1px #0090d3;
  }

  &:disabled {
    background-color: #f3f4f6;
    color: #9ca3af;
    cursor: not-allowed;
    opacity: 1;
  }
`

export const DeleteButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  margin: 0;
  flex-shrink: 0;
  
  img {
    width: 18px;
    height: 18px;
  }
`

export const AddItemButton = styled.button`
  background-color: transparent;
  color: #0090d3;
  border: 1px solid #0090d3;
  padding: 12px 24px;
  border-radius: 100px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 auto;
  
  img {
    width: 12px;
    height: 12px;
  }
`


export const TagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
  position: relative;
  z-index: 1;
`

export const Tag = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background-color: #FFFFFF;
  border: 1px solid #E5E7EB;
  border-radius: 100px;
  font-size: 14px;
  color: #374151;
`

export const RemoveTagButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  color: #6B7280;
  
  img {
    width: 10px;
    height: 10px;
  }
`

export const SelectContainer = styled.div<{ zIndex?: number; $flush?: boolean }>`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  z-index: ${props => props.zIndex ?? 'auto'};

  ${(props) =>
    props.$flush &&
    `
    align-items: stretch;
    align-self: stretch;
    min-height: 44px;
    justify-content: center;

    & > * {
      width: 100%;
      flex: 1;
      min-width: 0;
      min-height: 44px;
    }
  `}
`


export const GraduationSection = styled.div`
  margin-top: 24px;
`

export const GraduationLabel = styled.p`
  font-size: 14px;
  color: #303030;
  font-weight: bold;
  margin-bottom: 12px;
  margin: 0 0 12px 0;
`

export const PageGrid = styled.div<{ $asideOpen: boolean }>`
  display: grid;
  grid-template-columns: ${(p) => (p.$asideOpen ? 'minmax(0, 1fr) 360px' : 'minmax(0, 1fr) 64px')};
  gap: 20px;
  align-items: start;
  transition: grid-template-columns 0.2s ease;

  @media (max-width: 1100px) {
    grid-template-columns: minmax(0, 1fr);
  }
`

export const FormColumn = styled.div`
  min-width: 0;
`

export const AsideColumn = styled.aside`
  position: sticky;
  top: 0;
  align-self: start;
  max-height: calc(100vh - 32px);
  display: flex;
  flex-direction: column;
  z-index: 1;

  @media (max-width: 1100px) {
    position: static;
    max-height: none;
  }
`